import create from 'zustand';

type Entity = {
  id: string;
  name: string;
  isActive?: boolean;
};

type NavigationStore = {
  currentHospital: Entity | undefined;
  currentOrganisation: Entity | undefined;
  navigatedUser: Entity | undefined;
  reset: () => void;
  setCurrentHospital: (hospital: Entity | undefined) => void;
  setCurrentOrganisation: (organisation: Entity | undefined) => void;
  setNavigatedUser: (organisation: Entity | undefined) => void;
};

export const useNavigationStore = create<NavigationStore>((set) => ({
  currentHospital: undefined,
  currentOrganisation: undefined,
  navigatedUser: undefined,
  setCurrentHospital: (currentHospital) => set({ currentHospital }),
  setCurrentOrganisation: (currentOrganisation) => set({ currentOrganisation }),
  setNavigatedUser: (navigatedUser) => set({ navigatedUser }),
  reset: () => {
    set({
      currentHospital: undefined,
      currentOrganisation: undefined,
      navigatedUser: undefined,
    });
  },
}));
